<template>
  <div class="calico-dropdown-page">
    <h2>Calico Dropdown States</h2>
    <div class="calico-dropdown-container">
      <div class="dropdown-wrapper">
        <CalicoDropdown
          v-model="selectedValue"
          placeholder="Elige una opción..."
        >
          <CalicoDropdownMenuItem 
            v-for="option in options" 
            :key="option.value" 
            :value="option.value" 
            @click="selectedValue = option.value"
          >
            {{ option.label }}
          </CalicoDropdownMenuItem>
        </CalicoDropdown>
        <p>value: {{ selectedValue }}</p>
      </div>
      <div class="dropdown-wrapper">
        <CalicoDropdown
          v-model="disabledValue"
          disabled
        >
          <CalicoDropdownMenuItem 
            v-for="option in options" 
            :key="option.value" 
            :value="option.value" 
            @click="disabledValue = option.value"
          >
            {{ option.label }}
          </CalicoDropdownMenuItem>
        </CalicoDropdown>
        <p>value: {{ disabledValue }}</p>
      </div>
      <div class="dropdown-wrapper">
        <CalicoDropdown
          v-model="errorValue"
          :error="true"
        >
          <CalicoDropdownMenuItem 
            v-for="option in options" 
            :key="option.value" 
            :value="option.value" 
            @click="errorValue = option.value"
          >
            {{ option.label }}
          </CalicoDropdownMenuItem>
        </CalicoDropdown>
        <p>value: {{ errorValue }}</p>
      </div>
      <div class="dropdown-wrapper">
        <CalicoDropdown
          v-model="badgeValue"
          :show-badge="true"
          badge-color="badge-red"
          badge-label="Label"
        >
          <CalicoDropdownMenuItem 
            v-for="option in options2" 
            :key="option.value" 
            :value="option.value" 
            @click="badgeValue = option.value"
          >
            <span v-html="option.label" />
          </CalicoDropdownMenuItem>
        </CalicoDropdown>
        <p>value: {{ badgeValue }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoDropdown from '@/components/calico/dropdown/index.vue';
import CalicoDropdownMenuItem from '@/components/calico/dropdownMenuItem/index.vue';

export default {
  name: 'CalicoDropdownPage',
  components: {
    CalicoDropdown,
    CalicoDropdownMenuItem
  },
  data() {
    return {
      selectedValue: 'Select',
      disabledValue: 'Select',
      errorValue: 'Select',
      badgeValue: 'Select',
      options: [
        { value: 'option1', label: 'Option 1' },
        { value: 'option2', label: 'Option 2' },
        { value: 'option3', label: 'Option 3' },
      ],
      options2: [
        { value: 'option1', label: '<i class="bi bi-1-circle"></i>' },
        { value: 'option2', label: '<i class="bi bi-2-circle"></i>' },
        { value: 'option3', label: '<i class="bi bi-3-circle"></i>' },
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.calico-dropdown-page {
  @include stack-space($space-none);
  align-items: center;

  .calico-dropdown-container {
    @include stack-space($space-large);
    justify-content: center;
    align-items: center;
    width: 100%;

    .dropdown-wrapper {
      width: 50%;
    }
  }
}
</style>
